<template>
  <div
    class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 modal"
  >
    <div class="bg-gray-100 p-4 rounded shadow-md mb-6 modal-content">
      <h1 class="text-2xl font-bold mb-2">
        {{
          mode === "ajout"
            ? "Ajouter un chat"
            : mode === "modification"
            ? "Modifier le chat"
            : mode === "suppression"
            ? "Supprimer le chat"
            : ""
        }}
      </h1>
      <button
        @click="emit('fermer')"
        class="fermer text-primaire hover:text-navigation text-2xl hover:bg-gray-200 rounded-full px-2"
        aria-label="Fermer la modale" title="Fermer la modale"
      >
        &times;
      </button>
      <form @submit.prevent="onSubmit" class="bg-white p-6 rounded shadow-md mt-10 mb-10">
        <!-- Les champs du formulaire, comme dans vos exemples -->
        <label class="block mb-3">
          No. d'identification:
          <input
            v-model.number="chat.no_identification"
            type="number"
            required
            min="1"
            class="border-2 border-gray-300 rounded w-full px-2 py-1"
            aria-label="Numéro d'identification"
            title="Numéro d'identification du chat"
          />
        </label>
        <label class="block mb-3">
          Nom:
          <input
            v-model="chat.nom"
            type="text"
            required
            class="border-2 border-gray-300 rounded w-full px-2 py-1"
            aria-label="Nom"
            title="Nom du chat"
          />
        </label>
        <label class="block mb-3">
          Type (femelle, mâle):
          <input
            v-model="chat.type"
            type="text"
            required
            class="border-2 border-gray-300 rounded w-full px-2 py-1"
            aria-label="Type"
            title="Type de chat (femelle, mâle)"
          />
        </label>
        <label class="block mb-3">
          Date de naissance:
          <input
            v-model="chat.date_de_naissance"
            type="text"
            required
            class="border-2 border-gray-300 rounded w-full px-2 py-1"
            aria-label="Date de naissance"
            title="Date de naissance du chat (format: JJ-MMMM-AAAA)"
          />
        </label>
        <label class="block mb-3">
          Statut (chaton, chaton6-12, craintif, adulte):
          <input
            v-model="chat.statut"
            type="text"
            required
            class="border-2 border-gray-300 rounded w-full px-2 py-1"
          />
        </label>
        <label class="block mb-3">
          Stérilisée/Castré:
          <input v-model="chat.sterilisation" type="checkbox"
           aria-label="Stérilisée/Castré" title="Chat stérilisée ou castré" />
        </label>
        <label class="block mb-3">
          Vaccins:
          <input v-model="chat.vaccin" type="checkbox"
           aria-label="Vaccins" title="Vaccins du chat" />
        </label>
        <!-- <label class="block mb-3">
          1er vaccin
          <input v-model="chat.vaccin_1" type="text"
           class="border-2 border-gray-300 rounded w-full px-2 py-1"
           aria-label="1er vaccin"
           title="Détails du 1er vaccin du chat" />
        </label>
        <label class="block mb-3">
          2e vaccin
          <input v-model="chat.vaccin_2" type="text"
           class="border-2 border-gray-300 rounded w-full px-2 py-1"
           aria-label="2e vaccin"
           title="Détails du 2e vaccin du chat" />
        </label> -->
        <label class="block mb-3">
          Vermifuge:
          <input v-model="chat.vermifuge" type="checkbox"
           aria-label="Vermifuge" title="Vermifuge du chat" />
        </label>
        <label class="block mb-3">
          Info additionnelle:
          <textarea
            v-model="chat.info_additionnelle"
            class="border-2 border-gray-300 rounded w-full px-2 py-1"
            aria-label="Info additionnelle"
            title="Informations additionnelles sur le chat"
          ></textarea>
        </label>
        <label class="block mb-3">
          Date d'adoption (aaaa-mm-jj):
          <input
            v-model="chat.date_adoption"
            type="date"
            class="border-2 border-gray-300 rounded w-full px-2 py-1"
            aria-label="Date d'adoption"
            title="Date d'adoption du chat (format: aaaa-mm-jj)"
          />
        </label>
        <label class="block mb-3">
          Réservé(e):
          <select
            v-model="chat.reserve"
            class="border-2 border-gray-300 rounded w-full px-2 py-1"
            aria-label="Réservé(e)"
            title="Statut de réservation du chat"
          >
            <option value="oui">Oui</option>
            <option value="non">Non</option>
          </select>
        </label>
        <label class="block mb-3">
          Image SRC:
          <input
            v-model="chat.image"
            type="text"
            required
            class="border-2 border-gray-300 rounded w-full px-2 py-1"
            :alt="imageAccessibilityText"
            :aria-label="`URL de l'image - ${imageAccessibilityText}`"
            :title="`URL de l'image du ${imageAccessibilityText.toLowerCase()}`"
          />
        </label>
        <div class="flex justify-end gap-4 mt-6">
          <button
            type="button"
            @click="emit('fermer')"
            class="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
            aria-label="Annuler" title="Annuler les modifications"
          >
            Annuler
          </button>
          <slot name="actions">
            <!-- Actions personnalisées pour la modale -->
            <button
              v-if="!message && mode !== 'suppression'"
              type="submit"
              :class="
                mode === 'ajout'
                  ? 'bg-blue-500 hover:bg-blue-600'
                  : 'bg-green-600 hover:bg-green-700'
              "
              class="px-4 py-2 text-white rounded"
              aria-label="Ajouter/Sauvegarder" title="Ajouter ou sauvegarder le chat"
            >
              {{ mode === "ajout" ? "Ajouter" : "Sauvegarder" }}
            </button>
            <button
              v-if="props.afficherFermerApresSucces && message"
              type="button"
              @click="emit('fermer')"
              class="px-4 py-2 bg-green-500 hover:bg-green-600 text-white rounded"
              aria-label="Fermer" title="Fermer la modale"
            >
              Fermer
            </button>
          </slot>
        </div>
      </form>
      <p v-if="message" class="mt-2 text-green-600">{{ message }}</p>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, watch, computed } from "vue";

const props = defineProps({
  chatInitial: { type: Object, default: () => ({}) },
  mode: { type: String, default: "ajout" }, // 'ajout' ou 'modification'
  afficherFermerApresSucces: { type: Boolean, default: false },
});
const emit = defineEmits(["sauvegarder", "fermer"]);

// Initialisation complète avec valeurs par défaut
const chat = reactive({
  no_identification: "null",
  nom: "",
  type: "",
  date_de_naissance: "",
  statut: "",
  sterilisation: false,
  vaccin: false,
  vermifuge: false,
  info_additionnelle: "",
  image: "",
  reserve: "non",
  date_adoption: "",
  ...props.chatInitial, // Remplace les valeurs si modification
});

const imageAccessibilityText = computed(() => {
  return chat.nom ? `Chat ${chat.nom}` : "Image du chat";
});

const message = ref("");

// Conversion oui/non <-> booléen pour les cases à cocher
function syncCheckboxes(obj) {
  chat.sterilisation =
    obj.sterilisation === true || obj.sterilisation === "oui";
  chat.vaccin = obj.vaccin === true || obj.vaccin === "oui";
  chat.vermifuge = obj.vermifuge === true || obj.vermifuge === "oui";
}

watch(
  () => props.chatInitial,
  (nv) => {
    Object.assign(chat, nv);
    syncCheckboxes(chat);
  },
  { immediate: true }
);

async function onSubmit() {
  chat.no_identification = Number(chat.no_identification);
  if (
    !chat.no_identification ||
    isNaN(chat.no_identification) ||
    chat.no_identification <= 0
  ) {
    message.value =
      "Veuillez saisir un numéro d'identification valide et unique.";
    return;
  }
  // Conversion booléen -> oui/non pour les cases à cocher
  const chatToSave = {
    ...chat,
    sterilisation: chat.sterilisation ? "oui" : "non",
    vaccin: chat.vaccin ? "oui" : "non",
    vermifuge: chat.vermifuge ? "oui" : "non",
  };

  // Émettre avec message de succès selon le mode
  if (props.mode === "ajout") {
    emit("sauvegarder", chatToSave, "Chat ajouté avec succès !");
    message.value = "Chat ajouté avec succès !";
  } else if (props.mode === "modification") {
    emit("sauvegarder", chatToSave, "Chat modifié avec succès !");
    message.value = "Chat modifié avec succès !";
  } else if (props.mode === "suppression") {
    emit("sauvegarder", chatToSave, "Chat supprimé avec succès !");
    message.value = "Chat supprimé avec succès !";
  } else {
    emit("sauvegarder", chatToSave);
  }

  // Gestion de la fermeture si demandé
  if (props.afficherFermerApresSucces) {
    emit("fermer");
  }
}
</script>

<style scoped>
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: fixed;
  top: 20%;
  left: 50%;
  transform: translate(-50%, -20%);
  width: 90%;
  max-width: 600px;
  margin-top: 20px;
  margin-bottom: 20px;
  z-index: 500;
  background-color: rgba(0, 0, 0, 0.9);
  padding: 10px;
  border-radius: 8px;
}

.modal-content {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  width: 100%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-height: 80vh;
  overflow-y: auto;
}

.fermer {
  position: absolute;
  top: 32px;
  right: 40px;
  background-color: transparent;
  border: none;
  font-size: 32px;
  cursor: pointer;
}

.fermer:hover {
  color: #ff0000;
  padding: 0 8px;
  border-radius: 50%;
  background-color: #f2f2f2;
}
</style>
